import StoredLayout from '../../layouts/StoredLayout'
import Tooltips from './Tooltips'
export default StoredLayout(Tooltips)
